import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch} from 'vue';
    import { parts_search } from '../../module/invoices/module';
    import { Size } from '../../components/basic_button/size';

    interface RegisteredItemNameVendor {
        id: number,
        registered_item_name_id: number,
        part_name: string,
        vendor_id: number,
        created_at: Date,
        updated_at: Date
    }

    interface RegisteredProduct {
        id: number,
        name: string,
        created_at: Date|null,
        updated_at: Date|null,
        RegisteredItemNameVendors: RegisteredItemNameVendor[]
    }

    interface Props {
        registered_product: RegisteredProduct
    }

    interface PartSearchResponse {
        name: string,
        description: string        
    }

    // const fetchOptionsVendor = function(vendor_id: number) {
    //     return async function(search: string, loading: Function) {
    //         options_vendor_1.value = await fetchOptions(search, loading, 1, value_vendor_1.value.map((selected_part: PartSearchResponse) => selected_part.name))
    //     }
    // }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'edit_registered_product',
  props: {
    registered_product: { type: Object, required: true }
  },
  emits: ['save', 'cancel'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

    const props = __props

    const dat_editing_registered_product_name = ref("")

    watch(() => props.registered_product, (new_registered_product: RegisteredProduct) => {
        dat_editing_registered_product_name.value = new_registered_product.name
        value_vendor_1.value = new_registered_product.RegisteredItemNameVendors
            .filter((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return tmp_registered_item_name_vendor.vendor_id == 1
            })
            .map((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return {
                    name: tmp_registered_item_name_vendor.part_name,
                    description: tmp_registered_item_name_vendor.part_name
                } as PartSearchResponse
            })

        value_vendor_2.value = new_registered_product.RegisteredItemNameVendors
            .filter((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return tmp_registered_item_name_vendor.vendor_id == 2
            })
            .map((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return {
                    name: tmp_registered_item_name_vendor.part_name,
                    description: tmp_registered_item_name_vendor.part_name
                } as PartSearchResponse
            })

        value_vendor_3.value = new_registered_product.RegisteredItemNameVendors
            .filter((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return tmp_registered_item_name_vendor.vendor_id == 3
            })
            .map((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return {
                    name: tmp_registered_item_name_vendor.part_name,
                    description: tmp_registered_item_name_vendor.part_name
                } as PartSearchResponse
            })

        value_vendor_4.value = new_registered_product.RegisteredItemNameVendors
            .filter((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return tmp_registered_item_name_vendor.vendor_id == 4
            })
            .map((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return {
                    name: tmp_registered_item_name_vendor.part_name,
                    description: tmp_registered_item_name_vendor.part_name
                } as PartSearchResponse
            })

        value_vendor_5.value = new_registered_product.RegisteredItemNameVendors
            .filter((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return tmp_registered_item_name_vendor.vendor_id == 5
            })
            .map((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return {
                    name: tmp_registered_item_name_vendor.part_name,
                    description: tmp_registered_item_name_vendor.part_name
                } as PartSearchResponse
            })
        
        value_vendor_6.value = new_registered_product.RegisteredItemNameVendors
            .filter((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return tmp_registered_item_name_vendor.vendor_id == 6
            })
            .map((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return {
                    name: tmp_registered_item_name_vendor.part_name,
                    description: tmp_registered_item_name_vendor.part_name
                } as PartSearchResponse
            })

        value_vendor_7.value = new_registered_product.RegisteredItemNameVendors
            .filter((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return tmp_registered_item_name_vendor.vendor_id == 7
            })
            .map((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return {
                    name: tmp_registered_item_name_vendor.part_name,
                    description: tmp_registered_item_name_vendor.part_name
                } as PartSearchResponse
            })
        
        value_vendor_8.value = new_registered_product.RegisteredItemNameVendors
            .filter((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return tmp_registered_item_name_vendor.vendor_id == 8
            })
            .map((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return {
                    name: tmp_registered_item_name_vendor.part_name,
                    description: tmp_registered_item_name_vendor.part_name
                } as PartSearchResponse
            })

        value_vendor_9.value = new_registered_product.RegisteredItemNameVendors
            .filter((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return tmp_registered_item_name_vendor.vendor_id == 9
            })
            .map((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return {
                    name: tmp_registered_item_name_vendor.part_name,
                    description: tmp_registered_item_name_vendor.part_name
                } as PartSearchResponse
            })
        value_vendor_10.value = new_registered_product.RegisteredItemNameVendors
            .filter((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return tmp_registered_item_name_vendor.vendor_id == 10
            })
            .map((tmp_registered_item_name_vendor: RegisteredItemNameVendor) => {
                return {
                    name: tmp_registered_item_name_vendor.part_name,
                    description: tmp_registered_item_name_vendor.part_name
                } as PartSearchResponse
            })
    })

    const emit = __emit

    const cancel = function() {
        emit('cancel')
    }

    const save = function() {
        emit('save', com_registered_product.value)
    }

    const fetchOptions = async function(search: string, loading: Function, vendor_id: number, existing_part_names: string[]) {
        loading(true)
        const parts = await parts_search(search, vendor_id, existing_part_names)
        loading(false)
        return parts
    }

    const options_vendor_1 = ref([] as string[])
    const value_vendor_1 = ref([] as PartSearchResponse[])
    const fetchOptionsVendor1 = async function(search: string, loading: Function) {
        options_vendor_1.value = await fetchOptions(search, loading, 1, value_vendor_1.value.map((selected_part: PartSearchResponse) => selected_part.name))
    }
    
    const options_vendor_2 = ref([] as string[])
    const value_vendor_2 = ref([] as PartSearchResponse[])
    const fetchOptionsVendor2 = async function(search: string, loading: Function) {
        const qwer = await fetchOptions(search, loading, 2, value_vendor_2.value.map((selected_part: PartSearchResponse) => selected_part.name))
        options_vendor_2.value = qwer
    }
    
    const options_vendor_3 = ref([] as string[])
    const value_vendor_3 = ref([] as PartSearchResponse[])
    const fetchOptionsVendor3 = async function(search: string, loading: Function) {
        options_vendor_3.value = await fetchOptions(search, loading, 3, value_vendor_3.value.map((selected_part: PartSearchResponse) => selected_part.name))
    }
    
    const options_vendor_4 = ref([] as string[])
    const value_vendor_4 = ref([] as PartSearchResponse[])
    const fetchOptionsVendor4 = async function(search: string, loading: Function) {
        options_vendor_4.value = await fetchOptions(search, loading, 4, value_vendor_4.value.map((selected_part: PartSearchResponse) => selected_part.name))
    }
    
    const options_vendor_5 = ref([] as string[])
    const value_vendor_5 = ref([] as PartSearchResponse[])
    const fetchOptionsVendor5 = async function(search: string, loading: Function) {
        options_vendor_5.value = await fetchOptions(search, loading, 5, value_vendor_5.value.map((selected_part: PartSearchResponse) => selected_part.name))
    }

    const options_vendor_6 = ref([] as string[])
    const value_vendor_6 = ref([] as PartSearchResponse[])
    const fetchOptionsVendor6 = async function(search: string, loading: Function) {
        options_vendor_6.value = await fetchOptions(search, loading, 6, value_vendor_6.value.map((selected_part: PartSearchResponse) => selected_part.name))
    }

    const options_vendor_7 = ref([] as string[])
    const value_vendor_7 = ref([] as PartSearchResponse[])
    const fetchOptionsVendor7 = async function(search: string, loading: Function) {
        options_vendor_7.value = await fetchOptions(search, loading, 7, value_vendor_7.value.map((selected_part: PartSearchResponse) => selected_part.name))
    }

    const options_vendor_8 = ref([] as string[])
    const value_vendor_8 = ref([] as PartSearchResponse[])
    const fetchOptionsVendor8 = async function(search: string, loading: Function) {
        options_vendor_8.value = await fetchOptions(search, loading, 8, value_vendor_8.value.map((selected_part: PartSearchResponse) => selected_part.name))
    }

    const options_vendor_9 = ref([] as string[])
    const value_vendor_9 = ref([] as PartSearchResponse[])
    const fetchOptionsVendor9 = async function(search: string, loading: Function) {
        options_vendor_9.value = await fetchOptions(search, loading, 9, value_vendor_9.value.map((selected_part: PartSearchResponse) => selected_part.name))
    }

    const options_vendor_10 = ref([] as string[])
    const value_vendor_10 = ref([] as PartSearchResponse[])
    const fetchOptionsVendor10 = async function(search: string, loading: Function) {
        options_vendor_10.value = await fetchOptions(search, loading, 10, value_vendor_10.value.map((selected_part: PartSearchResponse) => selected_part.name))
    }

    const com_registered_product = computed(function () {
        const loc_value_vendor_1 = value_vendor_1.value.map((tmp_part_search_response: PartSearchResponse) => {
            return {
                part_name: tmp_part_search_response.name,
                vendor_id: 1,
            }
        })

        const loc_value_vendor_2 = value_vendor_2.value.map((tmp_part_search_response: PartSearchResponse) => {
            return {
                part_name: tmp_part_search_response.name,
                vendor_id: 2,
            }
        })

        const loc_value_vendor_3 = value_vendor_3.value.map((tmp_part_search_response: PartSearchResponse) => {
            return {
                part_name: tmp_part_search_response.name,
                vendor_id: 3,
            }
        })

        const loc_value_vendor_4 = value_vendor_4.value.map((tmp_part_search_response: PartSearchResponse) => {
            return {
                part_name: tmp_part_search_response.name,
                vendor_id: 4,
            }
        })

        const loc_value_vendor_5 = value_vendor_5.value.map((tmp_part_search_response: PartSearchResponse) => {
            return {
                part_name: tmp_part_search_response.name,
                vendor_id: 5,
            }
        })

        const loc_value_vendor_6 = value_vendor_6.value.map((tmp_part_search_response: PartSearchResponse) => {
            return {
                part_name: tmp_part_search_response.name,
                vendor_id: 6,
            }
        })

        const loc_value_vendor_7 = value_vendor_7.value.map((tmp_part_search_response: PartSearchResponse) => {
            return {
                part_name: tmp_part_search_response.name,
                vendor_id: 7,
            }
        })

        const loc_value_vendor_8 = value_vendor_8.value.map((tmp_part_search_response: PartSearchResponse) => {
            return {
                part_name: tmp_part_search_response.name,
                vendor_id: 8,
            }
        })

        const loc_value_vendor_9 = value_vendor_9.value.map((tmp_part_search_response: PartSearchResponse) => {
            return {
                part_name: tmp_part_search_response.name,
                vendor_id: 9,
            }
        })

        const loc_value_vendor_10 = value_vendor_10.value.map((tmp_part_search_response: PartSearchResponse) => {
            return {
                part_name: tmp_part_search_response.name,
                vendor_id: 10,
            }
        })

        return {
            name: dat_editing_registered_product_name.value,
            RegisteredItemNameVendors: loc_value_vendor_1
                .concat(loc_value_vendor_2)
                .concat(loc_value_vendor_3)
                .concat(loc_value_vendor_4)
                .concat(loc_value_vendor_5)
                .concat(loc_value_vendor_6)
                .concat(loc_value_vendor_7)
                .concat(loc_value_vendor_8)
                .concat(loc_value_vendor_9)
                .concat(loc_value_vendor_10)
        } as RegisteredProduct
    })


const __returned__ = { props, dat_editing_registered_product_name, emit, cancel, save, fetchOptions, options_vendor_1, value_vendor_1, fetchOptionsVendor1, options_vendor_2, value_vendor_2, fetchOptionsVendor2, options_vendor_3, value_vendor_3, fetchOptionsVendor3, options_vendor_4, value_vendor_4, fetchOptionsVendor4, options_vendor_5, value_vendor_5, fetchOptionsVendor5, options_vendor_6, value_vendor_6, fetchOptionsVendor6, options_vendor_7, value_vendor_7, fetchOptionsVendor7, options_vendor_8, value_vendor_8, fetchOptionsVendor8, options_vendor_9, value_vendor_9, fetchOptionsVendor9, options_vendor_10, value_vendor_10, fetchOptionsVendor10, com_registered_product, get Size() { return Size } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})